module.exports = __webpack_public_path__ + "static/img/4_Omnidataware_blog.137309c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qrcodes/4_Omnidataware_blog.png
// module id = 2bhj
// module chunks = 1